<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/pedidoAvulso"> Compras/ Pedido de Compra Local </router-link>
      <label class="labelBar"> / </label>
      <label> Inativar</label>
    </div>

    <div>
      <label><h2>Deseja realmente inativar o pedido N°{{ pedidoAvulso.id }}?</h2></label>
    </div>

    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <label>Justifique o motivo da inativacao:</label>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-textarea
              outlined
              v-model="justificativa"
              clear-icon="mdi-close-circle"
              label="Justificativa"
              prepend-icon="mdi-comment"
              maxlength="255"
              counter
              :rules="justificativaRules"
              required
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>

      <v-row align="center-left">
        <v-col cols="6" sm="2">
          <v-text-field label="N� Pedido" v-model="pedidoAvulso.id" readonly></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field label="Data" :value="dataFormatada" readonly></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field label="Fornecedor" :value="nomeFornecedor" readonly></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field label="Unidade Adm" :value="unidadeAdm" readonly></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field label="Status" :value="statusDescricao" readonly></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field label="Ativo" :value="pedidoAvulso.ativo ? 'Sim' : 'Nao'" readonly></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field label="Orcamento" :value="pedidoAvulso.orcamento" readonly></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field label="Condicao de Pagamento" :value="condicaoPagamento" readonly></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-textarea label="Observacao" :value="pedidoAvulso.observacao" rows="1" auto-grow readonly></v-textarea>
        </v-col>
      </v-row>

      <v-card>
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items-per-page="-1"
          :items="pedidoAvulso.produtos || []"
        >
          <template v-slot:item.valorUnitario="{ item }">
            <span>{{ money(item.valorUnitario) }}</span>
          </template>
          <template v-slot:item.desconto="{ item }">
            <span>{{ money(item.desconto) }}</span>
          </template>
          <template v-slot:item.total="{ item }">
            <span>{{ money(item.total) }}</span>
          </template>
        </v-data-table>
      </v-card>

      <v-col cols="12" sm="12" class="text-right">
        <v-btn to="/pedidoAvulso" color="error" class="mr-4"> Voltar </v-btn>
        <v-btn @click="enviar" color="success" class="mr-4" :disabled="!pedidoPodeSerInativado">
          Inativar
        </v-btn>
      </v-col>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { inativarPedidoAvulsoAsync } from "../../../services/pedidoAvulsoService";
import { canInactivateModule, isLoggedUserAdmin } from "@/services/loginService";

export default {
  name: "inativarPedidoAvulso",
  data: () => ({
    overlay: false,
    valid: true,
    justificativa: null,
    justificativaRules: [
      (v) => !!(v && v.trim()) || "A Justificativa e obrigatoria",
      (v) => !v || v.length <= 255 || "A Justificativa deve possuir no maximo 255 caracteres",
    ],
    headers: [
      { text: "Produto/Servico", value: "descricao", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Entrega", value: "prazoEntrega", sortable: false },
      { text: "Marca", value: "marca", sortable: false },
      { text: "Valor Unit", value: "valorUnitario", sortable: false },
      { text: "Desconto", value: "desconto", sortable: false },
      { text: "Total", value: "total", sortable: false },
    ],
  }),
  computed: {
    ...mapState("pedidoAvulso", ["pedidoAvulso"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    ...mapState("fornecedor", ["fornecedores"]),
    ...mapState("condicaoPagamento", ["condicoes"]),
    pedidoPodeSerInativado() {
      if (!this.pedidoAvulso || !this.pedidoAvulso.id) return false;
      if (!canInactivateModule(21)) return false;
      return this.pedidoAvulso.status === "PG" || (isLoggedUserAdmin() && this.pedidoAvulso.status !== "I");
    },
    dataFormatada() {
      if (!this.pedidoAvulso || !this.pedidoAvulso.data) return "";
      return new Date(this.pedidoAvulso.data).toLocaleString().replace(/(.*)\D\d+/, "$1");
    },
    nomeFornecedor() {
      if (this.pedidoAvulso.nomeFornecedor) return this.pedidoAvulso.nomeFornecedor;
      const fornecedor = this.fornecedores.find((f) => f.id === this.pedidoAvulso.idFornecedor);
      return fornecedor ? fornecedor.nome : "";
    },
    unidadeAdm() {
      if (this.pedidoAvulso.unidadeAdm) return this.pedidoAvulso.unidadeAdm;
      const local = this.locais.find((l) => l.id === this.pedidoAvulso.idUnidadeAdm);
      return local ? local.descricao : "";
    },
    condicaoPagamento() {
      if (this.pedidoAvulso.condicaoDePagamento) return this.pedidoAvulso.condicaoDePagamento;
      const condicao = this.condicoes.find((c) => c.id === this.pedidoAvulso.idCondicaoPagamento);
      return condicao ? condicao.descricao : "";
    },
    statusDescricao() {
      switch (this.pedidoAvulso.status) {
        case "PG": return "Pedido Gerado";
        case "EP": return "Entrada Parcial";
        case "B": return "Baixado";
        case "I": return "Inativo";
        default: return this.pedidoAvulso.status || "";
      }
    },
  },
  methods: {
    ...mapActions("pedidoAvulso", ["updatePedidoAvulso", "atualizarPedidosAvulso"]),
    async enviar() {
      if (!this.pedidoPodeSerInativado) {
        this.$alert("Desculpe. Esse pedido nao esta em um status permitido para inativacao!", "", "error");
        return;
      }

      if (!this.$refs.form.validate()) return;

      this.overlay = true;
      try {
        const resposta = await inativarPedidoAvulsoAsync(this.pedidoAvulso.id, this.justificativa.trim());
        if (resposta == null || resposta.status != 200) {
          this.$alert(resposta?.message || "Nao foi possivel inativar o pedido.", "Desculpe, falha na operacao!", "error");
          return;
        }

        const pedidoInativado = resposta.data || {
          ...this.pedidoAvulso,
          status: "I",
          ativo: false,
          justificativa: this.justificativa.trim(),
        };

        this.updatePedidoAvulso(pedidoInativado);
        await this.atualizarPedidosAvulso();
        this.$store.dispatch("ui/showSnackbar", {
          text: "Pedido Avulso inativado!",
          color: "success",
          timeout: 3000,
        });
        this.$router.push("/pedidoAvulso");
      } finally {
        this.overlay = false;
      }
    },
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
  created() {
    if (!this.pedidoAvulso || !this.pedidoAvulso.id) {
      this.$router.push("/pedidoAvulso");
    }
  },
};
</script>